import { render, staticRenderFns } from "./newbieGift.vue?vue&type=template&id=729b1928&scoped=true"
import script from "./newbieGift.vue?vue&type=script&lang=js"
export * from "./newbieGift.vue?vue&type=script&lang=js"
import style0 from "./newbieGift.vue?vue&type=style&index=0&id=729b1928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729b1928",
  null
  
)

export default component.exports